import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';
import { UserDAO } from '../../../core/services/dao/userDAO';

@Component({
  selector: 'app-messaging-dashboard',
  templateUrl: './messaging-dashboard.component.html',
  styleUrls: ['./messaging-dashboard.component.scss'],
})
export class MessagingDashboardComponent implements OnDestroy {
  userRole: 'admin' | 'owner' | 'captain' | undefined;

  subs: Subscription[] = [];

  constructor(private userDAO: UserDAO) {
    this.userRole = this.getUserRole();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  private getUserRole(): 'admin' | 'owner' | 'captain' {
    if (this.userDAO.currentUserIsAdmin()) return 'admin';
    if (this.userDAO.getCurrentUser()?.boatOwner) return 'owner';
    if (this.userDAO.getCurrentUser()?.captain) return 'captain';
  }
}
